var map = {
	"./SushiSwap.png": 7877,
	"./bitmart.png": 9748,
	"./comp1.png": 6753,
	"./comp2.png": 2931,
	"./comp3.jpg": 3576,
	"./comp4.png": 5013,
	"./cont1.png": 2797,
	"./cont10_bg.png": 2149,
	"./cont12_img1.png": 1754,
	"./cont12_img2.png": 3760,
	"./cont12_img3.png": 9311,
	"./cont12_img4.png": 4241,
	"./cont12_img5.png": 1853,
	"./cont12_img6.png": 2702,
	"./cont12_img7.png": 7153,
	"./cont13_bg1.jpg": 4149,
	"./cont13_bg1.png": 7094,
	"./cont13_bg10.jpg": 6657,
	"./cont13_bg2.png": 5713,
	"./cont13_bg3.png": 2205,
	"./cont13_bg4.png": 1681,
	"./cont13_bg5.png": 6972,
	"./cont13_bg6.png": 9216,
	"./cont13_bg7.png": 2807,
	"./cont13_bg8.png": 2894,
	"./cont13_bg9.jpg": 7325,
	"./cont3_bg.png": 4752,
	"./cont3_icon1.png": 5800,
	"./cont3_icon2.png": 3688,
	"./cont3_icon3.png": 9075,
	"./cont3_icon4.png": 1442,
	"./cont3_icon5.png": 1603,
	"./cont3_icon6.png": 7227,
	"./cont4_bg1.jpg": 7439,
	"./cont4_bg1.png": 7579,
	"./cont4_bg2.jpg": 9011,
	"./cont4_bg2.png": 469,
	"./cont4_bg3.png": 6173,
	"./cont5_icon.png": 377,
	"./cont5_img1.png": 6702,
	"./cont5_img2.png": 4027,
	"./deeplink.png": 5584,
	"./gate.png": 1621,
	"./glow.png": 5362,
	"./good.png": 5365,
	"./haibao.png": 4695,
	"./haibaocloud.png": 2926,
	"./huobi.png": 3449,
	"./hycons-img.png": 4597,
	"./hycons.png": 3440,
	"./line.png": 4210,
	"./mexc.svg": 2168,
	"./new1.jpg": 4738,
	"./new2.jpg": 9082,
	"./new3.png": 2519,
	"./new4.jpg": 2136,
	"./new5.jpg": 1998,
	"./new5.webp": 4372,
	"./new6.png": 5595,
	"./new7.jpg": 4708,
	"./new8.jpg": 7953,
	"./pancakeswap.png": 8542,
	"./partner1.png": 9014,
	"./partner2.png": 7592,
	"./partner3.png": 8020,
	"./partner4.png": 237,
	"./partner5.png": 4714,
	"./partner6.png": 4152,
	"./partner7.png": 6170,
	"./swft.png": 2964,
	"./tikeren.jpg": 6829,
	"./uniswap.png": 8294
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1612;